import { Alert, AlertTitle } from "@mui/material";

function ErrorPage({
    title = "Beklenmeyen Hata",
    description = "Bir hata oluştu, lütfen daha sonra tekrar deneyiniz.",
}: {
    title?: string;
    description?: string;
}) {
    return (
        <Alert severity="error" className="mt-2">
            <AlertTitle>{title}</AlertTitle>
            {description}
        </Alert>
    );
}

export default ErrorPage;
